<script lang="ts">
  import Fa from "svelte-fa";
  import { faTwitter } from "@fortawesome/free-brands-svg-icons";

  export let title: string;
  export let subtitle: string;
  export let twitter: string;
  export let date: string;
</script>

<main>
  <header id="title-block-header">
    <picture class="logo">
      <source srcset="/logo.webp 200w" type="image/webp" />
      <img
        src="/logo.png"
        width="200"
        alt="Abstract art generated with picbreeder, possibly representing the letters OL."
      />
    </picture>
    <h1 class="title">{title}</h1>
    <h2 class="subtitle">{subtitle}</h2>
  </header>
  <footer>
    <h3 class="author">
      <Fa icon={faTwitter} />
      <a href="https://twitter.com/{twitter}">Follow for updates</a>
    </h3>
    <h3 class="date">{date}</h3>
  </footer>
</main>

<style>
  main {
    text-align: center;
    margin: 3em auto;
  }

  h2,
  h3 {
    font-weight: 300;
    font-size: 1.8rem;
  }

  h3 {
    font-size: 1.3rem;
  }

  header > h1 {
    color: var(--main-header-colour);
    font-size: 3rem;
    font-weight: 100;
  }
</style>
